import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeSummerGuideFields {
  title: EntryFieldTypes.Symbol
  subscriptionType: EntryFieldTypes.Symbol<'Maths' | 'Reading'>
  gradePosition: EntryFieldTypes.Integer
  description?: EntryFieldTypes.Text
  cover: EntryFieldTypes.AssetLink
  file: EntryFieldTypes.AssetLink
  domains: EntryFieldTypes.Array<
    EntryFieldTypes.Symbol<'all' | 'au' | 'ca' | 'cn' | 'in' | 'int' | 'kr' | 'nz' | 'th' | 'uk' | 'us' | 'za'>
  >
  role?: EntryFieldTypes.Array<EntryFieldTypes.Symbol<'Subco' | 'Teacher'>>
  product?: EntryFieldTypes.Symbol<'fast_phonics' | 'mathseeds' | 'reading_eggs' | 'reading_eggspress'>
}

export type TypeSummerGuideSkeleton = EntrySkeletonType<TypeSummerGuideFields, 'summerGuide'>
export type TypeSummerGuide<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeSummerGuideSkeleton,
  Modifiers,
  Locales
>

export function isTypeSummerGuide<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeSummerGuide<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'summerGuide'
}

export type TypeSummerGuideWithoutLinkResolutionResponse = TypeSummerGuide<'WITHOUT_LINK_RESOLUTION'>
export type TypeSummerGuideWithoutUnresolvableLinksResponse = TypeSummerGuide<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypeSummerGuideWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> = TypeSummerGuide<
  'WITH_ALL_LOCALES',
  Locales
>
export type TypeSummerGuideWithAllLocalesAndWithoutLinkResolutionResponse<Locales extends LocaleCode = LocaleCode> =
  TypeSummerGuide<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypeSummerGuideWithAllLocalesAndWithoutUnresolvableLinksResponse<Locales extends LocaleCode = LocaleCode> =
  TypeSummerGuide<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
